import { Component } from "react";
import { Input, Form, Divider } from "antd";
import { getLangList } from '@/lib/i18n';
import { ReButton } from "@/components/refineElement";
import { modalFromLayout } from "@/lib/antdElementFunction";
import { hasPermission } from "@/lib/permissionUtil";

interface props {
  form?: any;
  categoryInfo: any;
  handleType: string;
  clickDelete: any;
}

class ModalCategory extends Component<props> {
  saleT: any = getLangList("sale");
  buttonT: any = getLangList("button");

  componentDidMount() {
    const { form, categoryInfo, handleType } = this.props;
    const {
      saleGroupName,
    } = categoryInfo ?? {};

    if (handleType === 'update') {
      form.setFieldsValue({
        saleGroupName,
      });
    }
  }

  render() {
    const { form, handleType, clickDelete } = this.props;

    return (
      <Form
        className="admin-form"
        style={{ marginTop: 20 }}
        {...modalFromLayout}
        form={form}
      >
        <Form.Item
          label={this.saleT.CATRGORY_NAME}
          name="saleGroupName"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>

        {handleType === 'update' && hasPermission('SALE_DELETE') &&
          <>
            <Divider dashed />
            <Form.Item label={this.buttonT.DELETE}>
              <ReButton onClick={clickDelete} attributeObject={{ type: "danger" }} iconName='delete' />
            </Form.Item>
          </>
        }
      </Form >
    );
  }
}

export default ModalCategory;